import {
  boolean,
  object,
  string,
  null as zNull,
  type infer as zInfer,
} from "zod/v4";

export const updateParentEasypostIntegration = {
  name: "updateParentEasypostIntegration" as const,
  input: object({
    integrationId: string(),
    enabled: boolean().optional(),
    prodApiKey: string().optional(),
    testApiKey: string().optional(),
  }),
  output: zNull(),
};

export type UpdateParentEasypostIntegrationInput = zInfer<
  typeof updateParentEasypostIntegration.input
>;
